import React from "react";
import { Result, Button } from "antd";
import { URLS } from "../../../LandingPage/constants";
import { UN_AUTHORIZEDTEXT } from "../../constants";

export default class Forbidden extends React.Component {
  render() {
    return (
      <Result
        status="403"
        title="403"
        subTitle={UN_AUTHORIZEDTEXT}
        extra={
          <Button type="primary" href={`${URLS.BASEROUTE}`}>
            Back Home
          </Button>
        }
      />
    );
  }
}
